// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"63b857b8","453":"2b9e5af2","554":"dbd10561","618":"67b5dd19","910":"6ea8bd22","914":"1281fbb0"}[chunkId] + ".chunk.js";
};